import Sortable from "@stimulus-components/sortable"

export class Controller extends Sortable {
  connect() {
    super.connect()
  }

  async onUpdate(event) {
    await super.onUpdate(event)

    Turbo.visit(window.location.href, { action: "replace" })
  }
}
